import { Flex, Text } from '@vtex/admin-ui'
import { useWatch } from '@vtex/admin-ui-form'
import { FormattedMessage, useIntl } from 'react-intl'
import { Item } from 'typings'
import {
  FieldGroupBox,
  Section,
  SectionContent,
  SectionHeader,
  SectionTitle,
  useDrawerState,
  useFormStateContext,
  useFormValidation,
} from 'ui'
import { AudienceEditor } from './AudienceEditor'
import { AudienceView } from './AudienceView'
import { messages } from './messages'
import { sectionSuite } from './validation'
import { styles } from './styles'

type Props = {
  name: string
}

export function AudienceSection(props: Props) {
  const { name } = props

  const { form } = useFormStateContext()

  const editorState = useDrawerState()

  const audiences: Item[] | undefined = useWatch({
    form,
    name,
  })

  const intl = useIntl()

  const handleSave = (values: Item[] | undefined) => {
    form.clearErrors(name)
    form.setValue(name, values)
  }

  useFormValidation('campaign-audiences', {
    fieldName: name,
    validateFn: sectionSuite(intl, name),
  })

  return (
    <Section>
      <FieldGroupBox name={name} withBorder={false}>
        <SectionHeader>
          <Flex direction="column" align="baseline">
            <SectionTitle>
              <FormattedMessage {...messages.title} />
            </SectionTitle>
            <Text tone="secondary">
              <FormattedMessage {...messages.subtitle} />
            </Text>
          </Flex>
        </SectionHeader>
        <SectionContent space="$space-10" fluid className={styles.content}>
          <AudienceView
            values={audiences}
            onAdd={editorState.show}
            onRemove={() => handleSave(undefined)}
          />
          <AudienceEditor
            state={editorState}
            onSave={handleSave}
            initalValues={audiences}
          />
        </SectionContent>
      </FieldGroupBox>
    </Section>
  )
}
